import React                      from 'react' ;
import { Button
       , Input
       , Layout
       }                          from 'antd' ;
import { Observer }               from 'mobx-react' ;

import { TEXT
       , tr }                     from '../00_assets' ;
import { API }                    from '../02_api' ;
import { CorporativeLogo
       , ModalPrompt
       , ProductLogo
       , SelectLang
       }                          from '../10_ui' ;

import { MLogin }                 from './01_screen_login_model' ;
import { MResetPass
       , ResetPassEditor }        from './02_screen_login_reset_password' ;


export const LoginScreen: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MLogin.instance( ) ;

  return <div className="login-layout flex-row flex-1 flex-align-center flex-justify-center">
          <div style={{ position: 'absolute', top: 14, right: 14 }}><SelectLang style={{width: 62}}/></div>
          <div className="brand-side flex-1 flex-col h-100 position-relative p-4">
            <div className="login-bkg" />
            <CorporativeLogo />
            <div className="mt-4 login-quality-points" dangerouslySetInnerHTML={{ __html: tr( TEXT.LOGIN_QUALITY_POINTS ) }} />
          </div>
          <div className="login-side flex-1 h-100 flex-col flex-align-center">
              <div className="flex-1" style={{minHeight: '150px'}} />
              <ProductLogo className="dark" />
              <div className="login-slogan mt-2 mb-4">
                { tr( TEXT.LOGIN_SLOGAN ) }
              </div>
              <form className="login-modal" onSubmit={ model.on_login }>
                <Input
                  placeholder={ tr( TEXT.UI_LOGIN_CLOUDNAME ) }
                  autoFocus={true}
                  value={ model.cloud }
                  onChange={ model.on_cloud_change }
                />
                <Input
                  placeholder={ tr( TEXT.UI_LOGIN_USERNAME ) }
                  className="mt-1"
                  value={ model.user }
                  onChange={ model.on_user_change }
                />
                <Input
                  placeholder={ tr( TEXT.UI_LOGIN_PASSWORD ) }
                  type="password"
                  className="mt-1"
                  value={ model.pass }
                  onChange={ model.on_pass_change }
                />
                { model.error.length > 0? <div className="text-danger mt-2 p-2">{ model.error }</div> : <div /> }
                <Button
                  disabled={ model.login_button_disable }
                  className="mt-3 w-100"
                  type="primary"
                  htmlType="submit"
                >
                  { tr( TEXT.UI_BUTTON_LOGIN ) }
                </Button>
                <Button onClick={ reset_password } type="link" className="ml-auto mt-3 mr-auto d-block">
                    { tr( TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ) }
                </Button>
              </form>
              <div className="flex-1" style={{minHeight: '150px'}} />
              <MainFooter />
          </div>
        </div>
} } />


function reset_password ( )
{
  const editor_model = new MResetPass( ) ;

  ModalPrompt( tr( TEXT.LOGIN_FORGOT_PASSWORD_TITLE )
            , <ResetPassEditor model={ editor_model } />
            , ( ) => API.RESET_PASSWORD.add!( editor_model.fields )
            , "question"
            , tr( TEXT.UI_BUTTON_SEND )
            ) ;
}


const MainFooter: React.FC = ( ) =>
<Observer render={ ( ) =>
{
  const links = [
    { href: tr( TEXT.LEGAL_TOS_LINK     ), text: tr( TEXT.LEGAL_TOS_TEXT ) }
  , { href: tr( TEXT.LEGAL_PRIVACY_LINK ), text: tr( TEXT.LEGAL_PRIVACY_TEXT ) }
  , { href: tr( TEXT.LEGAL_MODEL_LINK ), text: tr( TEXT.LEGAL_MODEL_TEXT ) }
  ] ;
  
  return <Layout.Footer style={{ textAlign: 'center' }} className="w-100">
       <ul className="flex-row">
         { links.map( link => 
            <li key={ link.href } className="flex-1 text-center">
              <a target="_blank"
               rel="noopener noreferrer"
               href={ link.href }>{ link.text }</a>
            </li>
         )}
      </ul>
     </Layout.Footer> ;
} } />
